import { MALDIVES_COUNTRY_CODE, MALDIVES_COUNTRY_NAME } from 'constants/charterFlight'
import Places from 'constants/places'

/**
 * Checks if a hotel offer is located in Maldives.
 * Supports both LE Hotel offers (property.geoData.countryCode) and
 * Bedbank offers (property.address.countryCode).
 *
 * @param offer - The hotel offer to check
 * @returns true if the hotel is in Maldives
 */
export function isMaldivesHotel(offer: App.HotelOffer | App.Offer | App.OfferSummary | App.BedbankOffer | undefined): boolean {
  if (!offer) return false

  // LE Hotel offers use property.geoData.countryCode
  // Bedbank offers use property.address.countryCode
  const property = offer.property as (App.OfferProperty & { address?: App.BedbankPropertyAddress }) | undefined
  const countryCode = property?.geoData?.countryCode ?? property?.address?.countryCode
  if (!countryCode) return false

  return countryCode.toUpperCase() === MALDIVES_COUNTRY_CODE
}

/**
 * Checks if a country code or name matches Maldives.
 *
 * @param value - Country code (e.g., 'MV') or country name (e.g., 'Maldives')
 * @returns true if it matches Maldives
 */
export function isMaldivesLocation(value?: string | null): boolean {
  if (!value) return false

  const trimmed = value.trim()
  if (!trimmed) return false

  return (
    trimmed.toUpperCase() === MALDIVES_COUNTRY_CODE ||
    trimmed.toLowerCase() === MALDIVES_COUNTRY_NAME
  )
}

export function isMaldivesDestinationSearch(destinationId?: string, destinationName?: string, destinationCountry?: string | null): boolean {
  return !!destinationId?.split(',').includes(Places.Maldives.id) ||
    isMaldivesLocation(destinationName) ||
    isMaldivesLocation(destinationCountry)
}
